import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable, OnInit } from '@angular/core';
import { authenticationService } from './Services/authenticationService';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { FileVm } from './Models/fileVm';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class uploadService {
  MixedContent: { files: File[] | File; previousAttachments: FileVm[] | FileVm };

  headers = new HttpHeaders();
  constructor(public http: HttpClient, private authenticationSerives: authenticationService) {
    this.authenticationSerives.createAuthorizationHeader();
    this.headers = this.authenticationSerives.headers;
  }

  getAuthorizationHeader() {
    return new HttpHeaders({
      'ngrok-skip-browser-warning': 'true',
      Authorization: 'Bearer ' + sessionStorage.getItem('serviceAdmintoken'),
    });
  }

  updateFiles(data: { files; previousAttachments }) {
    this.MixedContent = data;
  }
  creatFormData(data) {
    const formData = new FormData();
    for (let file of data) {
      formData.append(file.name, file);
    }
    return formData;
  }

  SelectFileType(fileName: string): string {
    let fileExtension: string = this.getFileExtension(fileName)
    if (fileExtension != null) {
      // Images
      const photoArr: string[] = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'svg', 'webp'];
      // Videos
      const videoArr: string[] = ['mp4', 'avi', 'mkv', 'mov', 'webm'];
      // Audio
      const audioArr: string[] = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a'];
      // Documents
      const documentArr: string[] = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'rtf', 'odt', 'csv', 'md', 'log'];
      // Code & markup
      const codeArr: string[] = ['html', 'htm', 'css', 'js', 'json', 'xml', 'yaml', 'yml', 'cs', 'cpp', 'java', 'py', 'ts'];
      // Compressed
      const compressedArr: string[] = ['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'iso'];
      // Executables & scripts
      const executableArr: string[] = ['exe', 'dll', 'bat', 'sh'];
      if (photoArr.includes(fileExtension)) {
        return "photo";
      }
      else if (videoArr.includes(fileExtension)) {
        return "video";
      }
      else if (audioArr.includes(fileExtension)) {
        return "audio";
      }
      else if (documentArr.includes(fileExtension)) {
        return "document";
      }
      else if (compressedArr.includes(fileExtension)) {
        return "archive";
      }
      else if (executableArr.includes(fileExtension)) {
        return "file";
      }
      else {
        return "other"
      }
    }
  }

  getFileExtension(filename: string): string | null {
    const index = filename.lastIndexOf('.');
    if (index !== -1 && index < filename.length - 1) {
      return filename.substring(index + 1);
    }
    return null;
  }

  uploadFile(selectedImage?: File, p0?: boolean): Observable<any> {
    if (
      Array.isArray(this.MixedContent.files) &&
      this.MixedContent.files.length == 0 &&
      this.MixedContent.previousAttachments
    )
      return of(this.MixedContent.previousAttachments);
    else {
      let formData = this.creatFormData(this.MixedContent.files);
      return this.http.post<any>(environment.apiUrl + 'UploadFile/Upload', formData, {
        headers: this.getAuthorizationHeader(),
      });
    }
  }

  // uploadMultipleFiles(): Observable<any> {
  //   if (!this.MixedContent.files) return of(this.MixedContent.previousAttachments);
  //   else {
  //     let formData = this.creatFormData(this.MixedContent.files);
  //     return this.http
  //       .post<any>(environment.apiUrl + 'UploadFile/UploadMultiple', formData, {
  //         headers: this.getAuthorizationHeader(),
  //       })
  //       .pipe(
  //         map((res: any) => {

  //           console.log('res', res);

  //           let editedResponse = res.map((item) => {
  //             return {
  //               fileName: item,
  //             };
  //           });

  //           let modifiedResponse;
  //           if (
  //             Array.isArray(this.MixedContent.previousAttachments) &&
  //             this.MixedContent.previousAttachments.length > 1
  //           ) {
  //             modifiedResponse = [...editedResponse, ...this.MixedContent.previousAttachments];

  //             console.log('modifiedResponse', modifiedResponse);

  //             return of(modifiedResponse);
  //           } else if (!Array.isArray(this.MixedContent.previousAttachments) && this.MixedContent.previousAttachments) {
  //             modifiedResponse = [...editedResponse, this.MixedContent.previousAttachments];
  //             return of(modifiedResponse);
  //           } else {
  //             modifiedResponse = [...editedResponse];
  //             return modifiedResponse as Observable<any> ;
  //           }
  //         }),
  //         // tap((res: any) => {
  //         //   let editedResponse = Array.from(res).map((item) => {
  //         //     return {
  //         //       fileName: item,
  //         //     };
  //         //   });

  //         //   let modifiedResponse;
  //         //   if (
  //         //     Array.isArray(this.MixedContent.previousAttachments) &&
  //         //     this.MixedContent.previousAttachments.length > 1
  //         //   ) {
  //         //     modifiedResponse = [...editedResponse, ...this.MixedContent.previousAttachments];

  //         //     console.log('modifiedResponse', modifiedResponse);

  //         //     return of(modifiedResponse);
  //         //   } else if (!Array.isArray(this.MixedContent.previousAttachments) && this.MixedContent.previousAttachments) {
  //         //     modifiedResponse = [...editedResponse, this.MixedContent.previousAttachments];
  //         //     return of(modifiedResponse);
  //         //   } else {
  //         //     modifiedResponse = [...editedResponse];
  //         //     return of(modifiedResponse);
  //         //   }
  //         // }),
  //         catchError((err) => {
  //           console.log('Error occurred during file upload:', err);
  //           // Return an observable with an error message or rethrow the error
  //           return throwError(() => new Error('File upload failed. Please try again.'));
  //         })
  //       );
  //   }
  // }



  uploadMultipleFiles(): Observable<FileVm[]> {
    if (Array.isArray(this.MixedContent.files) && this.MixedContent.files.length == 0) {
      // Return an Observable of previous attachments if no files are present
      if (Array.isArray(this.MixedContent.previousAttachments) && this.MixedContent.previousAttachments.length == 0) {
        return of([]);
      } else {
        return of(this.MixedContent.previousAttachments as FileVm[]);
      }
    } else {
      let formData = this.creatFormData(this.MixedContent.files);
      // Post the files and handle the response
      return this.http
        .post<any>(environment.apiUrl + 'UploadFile/UploadMultiple', formData, {
          headers: this.getAuthorizationHeader(),
        })
        .pipe(
          map((res: any) => {
            let editedResponse = res.map((item) => {
              return {
                fileName: item,

              };
            });

            let modifiedResponse;
            if (
              Array.isArray(this.MixedContent.previousAttachments) &&
              this.MixedContent.previousAttachments.length > 1
            ) {
              // Combine new response with previous attachments
              modifiedResponse = [...editedResponse, ...this.MixedContent.previousAttachments];
              console.log('modifiedResponse', modifiedResponse);
            } else if (
              Array.isArray(this.MixedContent.previousAttachments) &&
              this.MixedContent.previousAttachments.length == 1
            ) {
              // Combine new response with a single previous attachment
              console.log('single previous');
              modifiedResponse = [...editedResponse, this.MixedContent.previousAttachments[0]];
            } else {
              // Just return the edited response
              modifiedResponse = [...editedResponse];
            }
            return modifiedResponse;
          }),
          tap((res: any) => {
            console.log('res', res);
          })
        );
    }
  }

  downloadFile(filename) {
    return this.http.post<any>(
      environment.apiUrl + 'UploadFile/Download',
      { filename: filename },
      { headers: this.getAuthorizationHeader() }
    );
  }

  uploadImage(files: FormData | FileVm) {
    if (!(files instanceof FormData)) {
      return of(files);
    } else {
      return this.http.post<any>(environment.apiUrl + 'UploadFile/Upload', files, {
        headers: this.getAuthorizationHeader(),
      });
    }
  }

  uploadPhoto(formData: FormData): Observable<FileVm> {
    return this.http.post<FileVm>(
      environment.apiUrl + 'UploadFile/Upload',
      formData,
      { headers: this.getAuthorizationHeader() }
    );
  }

  saveFile(object: any) {
    return this.http.post(environment.apiUrl + 'UploadFile/SaveFile', object);
  }

  isFilesEmpty() {
    if (
      this.MixedContent &&
      this.MixedContent.files &&
      Array.isArray(this.MixedContent.files) &&
      this.MixedContent.files.length > 0
    )
      return false;
    return true;
  }

  isPrevAttachementsEmpty() {
    if (
      this.MixedContent &&
      this.MixedContent.previousAttachments &&
      Array.isArray(this.MixedContent.previousAttachments) &&
      this.MixedContent.previousAttachments.length > 0
    )
      return false;
    return true;
  }
}
